module.exports = __webpack_public_path__ + "static/media/personal-data-cards.13759746.svg";